import React from "react";
import { Helmet } from "react-helmet";

import {
  Navbar,
  Footer,
  Landing,
  About,
  Skills,
  Testimonials,
  Blog,
  Education,
  Experience,
  Contacts,
  /* Projects, */ Services /* Achievement, */,
} from "../../components";
import { headerData } from "../../data/headerData";

function Main() {
  return (
    <div>
      <Helmet>
        <title>{headerData.name} — {headerData.title} | Portfolio</title>
        <meta
          name="description"
          content="Annshiv — Software Developer based in Chennai, India. Product Developer at Lumel building web applications with React & TypeScript. Explore my work, blog and resume."
        />
      </Helmet>

      <Navbar />
      <Landing />
      <About />
      <Education />
      <Skills />
      <Experience />
      {/* <Projects /> */}
      {/* <Achievement /> */}
      <Services />
      <Blog />
      <Testimonials />
      <Contacts />
      <Footer />
    </div>
  );
}

export default Main;
